module.exports = __webpack_public_path__ + "img/open-folder.2c952431.svg";